import React, { useState } from "react";
import { ConfirmPopup } from "../Confirmation";
import { postColumnsConfig } from "../config/Posts";

export const getPostColumns = ({ onDeleteClick, onEditClick, onViewClick }) => {
  const [confirmOpenForId, setConfirmOpenForId] = useState(null);

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    } catch {
      return dateString;
    }
  };

  return [
    {
      name: <span className="font-weight-bold fs-13">{postColumnsConfig.AUTHOR}</span>,
      selector: (row) => row.author?.firstname || "",
      cell: (row) => (
        <span title={`${row.author?.firstname || ""} ${row.author?.lastname || ""}`}
          style={{ cursor: "pointer" }}
        >
          {row.author ? `${row.author.firstname} ${row.author.lastname}` : "-"}
        </span>
      ),
    },
    {
      name: <span className="font-weight-bold fs-13">{postColumnsConfig.DESCRIPTION}</span>,
      selector: (row) => row.description || "",
      sortable: true,
      width: "450px",
      cell: (row) => (
        <div
          onClick={() => onViewClick?.(row)}
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            cursor: "pointer",
            width: "100%",
          }}
          title={row.description}
        >
          {row.description || "-"}
        </div>
      ),
    },

    // {
    //   name: <span className="font-weight-bold fs-13">{postColumnsConfig.MEDIATYPE}</span>,
    //   selector: (row) => row.mediaType || "",
    //   sortable: true,
    //   cell: (row) => row.mediaType || "-",
    // },
    {
      name: <span className="font-weight-bold fs-13">{postColumnsConfig.CREATED}</span>,
      selector: (row) => row.createdAt || "",
      sortable: true,
      cell: (row) => formatDate(row.createdAt),
    },
    {
      name: <span className="font-weight-bold fs-13">{postColumnsConfig.ACTIONS}</span>,
      sortable: false,
      cell: (row) => (
        <div className="d-flex align-items-center justify-content-center gap-2">
          {/* Edit */}
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              onEditClick?.(row);
            }}
            className="text-decoration-none px-1 py-2"
            title="Edit"
          >
            <i className="ri-edit-2-fill fs-13 text-primary p-2 rounded-circle shadow-sm bg-f1" />
          </a>

          {/* Delete */}
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              setConfirmOpenForId(row._id);
            }}
            className="text-decoration-none px-1 py-2"
            title="Delete"
          >
            <i className="ri-delete-bin-7-fill fs-13 text-danger p-2 rounded-circle shadow-sm bg-f1" />
          </a>

          {confirmOpenForId === row._id && (
            <ConfirmPopup
              message={postColumnsConfig.message}
              setConfirmOpen={() => setConfirmOpenForId(null)}
              onConfirm={(event) => {
                onDeleteClick?.(event, row._id);
                setConfirmOpenForId(null);
              }}
            />
          )}
        </div>
      ),
    },
  ];
};
